const socialMediaDomains = [
  { domain: /instagram\.com/, platform: 'Instagram' },
  { domain: /facebook\.com/, platform: 'Facebook' },
  { domain: /youtube\.com/, platform: 'YouTube' },
  { domain: /twitter\.com/, platform: 'Twitter' },
  { domain: /tiktok\.com/, platform: 'TikTok' },
  { domain: /trustpilot\.com/, platform: 'Trustpilot' },
  { domain: /linkedin\.com/, platform: 'LinkedIn' },
];

/**
 * Extracts the company name or platform from a social media link.
 *
 * @param {string} link - The social media link to extract the company name from.
 * @returns {string} The extracted company name or platform.
 */
const extractCompanyName = (link) => {
  if (!link) {
    return '';
  }

  try {
    const url = new URL(link);
    const host = url.hostname;

    for (const { domain, platform } of socialMediaDomains) {
      if (host.match(domain)) {
        const urlParts = url.pathname
          .replace(/^\/|\/$/g, '')
          .split('/')
          .filter((part) => part.length > 0);
        return urlParts[urlParts.length - 1] || platform;
      }
    }
  } catch (error) {
    // console.error(link, error);
    return link || '';
  }

  return link || '';
};

export default extractCompanyName;
